/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../utils/Functions';


const ShutterWindow = ({ width, height, trimWidth, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    const shutterWidth = width / 2;
    const shutterRailHeight = height / 8;
    const shutterRailDistanceY = height / 4;    
    const windowWidth = width - trimWidth * 4
    const windowHeight = (height - trimWidth * 4) / 2

    const outTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        hole.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const insideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        model.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.lineTo(-width / 2 + (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.closePath();
        
        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const shutterPanModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-shutterWidth / 2, -height / 2);
        model.lineTo(-shutterWidth / 2, height / 2);
        model.lineTo(shutterWidth / 2, height / 2);
        model.lineTo(shutterWidth / 2, -height / 2);
        model.closePath();

        return model;
    
    }, [width, height])

    const shutterRailModel = useMemo(() => {
        let model = []
        
        const upperModel = new THREE.Shape();
        upperModel.moveTo(-shutterWidth / 2, shutterRailDistanceY - shutterRailHeight / 2);
        upperModel.lineTo(-shutterWidth / 2, shutterRailDistanceY + shutterRailHeight / 2);
        upperModel.lineTo(shutterWidth / 2, shutterRailDistanceY + shutterRailHeight / 2);
        upperModel.lineTo(shutterWidth / 2, shutterRailDistanceY - shutterRailHeight / 2);
        upperModel.closePath();

        const underModel = new THREE.Shape();
        underModel.moveTo(-shutterWidth / 2, -(shutterRailDistanceY - shutterRailHeight / 2));
        underModel.lineTo(-shutterWidth / 2, -(shutterRailDistanceY + shutterRailHeight / 2));
        underModel.lineTo(shutterWidth / 2, -(shutterRailDistanceY + shutterRailHeight / 2));
        underModel.lineTo(shutterWidth / 2, -(shutterRailDistanceY - shutterRailHeight / 2));
        underModel.closePath();

        model.push(upperModel);
        model.push(underModel);

        return model;
    
    }, [width, height])
    
    const windowTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, -windowHeight / 2);
        model.lineTo(-windowWidth / 2, -windowHeight / 2);
        model.closePath();
        
        const hole = new THREE.Path();
        hole.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.closePath();

        model.holes.push(hole);

        return model;
    
    }, [width, height, trimWidth])

    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.closePath();

        return model
    
    }, [width, height, trimWidth])
    
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[outTrimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='inside-trim'>
                <extrudeGeometry args={[insideTrimModel, extrudeSettings(0.31)]} />
                <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.2}  />
            </mesh>
            {new Array(2).fill("").map((_, index) =>
                <group key={`shutter-model-${index}`} name='shutter' position={[Math.pow(-1, index) * (width / 2 + shutterWidth / 2), 0, 0.1]}>
                    <mesh name='pattern-pan' position={[0, 0, 0.2]}>
                        <extrudeGeometry args={[shutterPanModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} />
                    </mesh>
                    <mesh name='pattern-rail' position={[0, 0, 0.25]}>
                        <extrudeGeometry args={[shutterRailModel, extrudeSettings(0.06)]} />
                        <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.3}  />
                    </mesh>
                </group>
            )}
            {new Array(2).fill("").map((_, index) =>
                <group key={`window-model-${index}`} name='window-model' position={[0, Math.pow(-1, index) * (-windowHeight / 2), 0.1 + 0.1 * index]}>
                    <mesh name='glass-trim'>
                        <extrudeGeometry args={[windowTrimModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.3} />
                    </mesh>
                    <mesh name='glass' position={[0, 0, 0.01]}>
                        <extrudeGeometry args={[glassModel, extrudeSettings(0.08)]} />
                        <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
                    </mesh>
                </group>
            )}
        </>
    )
}

export default ShutterWindow